import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Account } from '../../models/account.model';

export interface UserResponse {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  fullName?: string;
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class UserService {
  private apiUrl = environment.api;

  constructor(private http: HttpClient) {}

  // Centralized default headers for JSON requests
  private defaultHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
  }

  getUserById(userId?: string): Observable<UserResponse> {
    const id = userId || '';
    const url = `${this.apiUrl}/api/v1/users/${id}`;
    console.log('[UserService] GET user by ID:', { url, id });
    return this.http.get<UserResponse>(url);
  }

  /**
   * Fetch account by id using endpoint: /api/v1/accounts/{accountId}
   */
  getAccountById(accountId: string): Observable<Account> {
    const id = accountId || '';
    const url = `${this.apiUrl}/api/v1/accounts/${id}`;
    console.log('[UserService] GET account by id:', { url, accountId: id });
    return this.http.get<Account>(url);
  }

  /**
   * Call the paginated customers detail endpoint and send customerId and serviceCenterId
   * The payload will prefer values from localStorage (cid/scid) as requested.
   */
  getCustomerAccountByUserId(
    serviceCenterId?: string,
    userId?: string,
  ): Observable<any> {
    const scid = localStorage.getItem('scid') || serviceCenterId || '';
    const cid = localStorage.getItem('cid') || userId || '';

    const url = `${this.apiUrl}/api/v1/customers/get-customers-detail-paginated`;
    const body = {
      customerId: cid,
      serviceCenterId: scid,
    };

    console.log(
      '[UserService] POST getCustomerAccountByUserId -> paginated endpoint:',
      {
        url,
        body,
      },
    );

    return this.http
      .post<any>(url, body, { headers: this.defaultHeaders() })
      .pipe(
        tap((resp) =>
          console.log(
            '[UserService] getCustomerAccountByUserId response:',
            resp,
          ),
        ),
        catchError((err) => {
          console.error('[UserService] getCustomerAccountByUserId error:', err);
          throw err;
        }),
      );
  }
}
